import React from 'react';

import { Card, labelClass } from '../ui';
import {
  fieldClass,
  LOCATIONS,
  PROVIDERS,
  TClassForm,
  TSetField,
} from './shared';

type Props = {
  form: TClassForm;
  set: TSetField;
};

/** Where the learners are, and who provides the video link. */
const LocationSection: React.FC<Props> = ({ form, set }) => (
  <Card title="Class Location">
    <div className="grid grid-cols-1 gap-4 p-5 md:grid-cols-3">
      <div>
        <label className={labelClass}>Student location</label>
        <select
          className={fieldClass}
          value={form.location}
          onChange={(e) => set('location')(e.target.value)}
        >
          {LOCATIONS.map((l) => (
            <option key={l}>{l}</option>
          ))}
        </select>
      </div>
      <div>
        <label className={labelClass}>Location address</label>
        <input
          className={fieldClass}
          placeholder="For onsite classes"
          value={form.locationAddress}
          onChange={(e) => set('locationAddress')(e.target.value)}
        />
      </div>
      <div>
        <label className={labelClass}>Video conference provider</label>
        <select
          className={fieldClass}
          value={form.videoProvider}
          onChange={(e) => set('videoProvider')(e.target.value)}
        >
          {PROVIDERS.map((pr) => (
            <option key={pr}>{pr}</option>
          ))}
        </select>
      </div>
    </div>
  </Card>
);

export default LocationSection;
